module.exports = __webpack_public_path__ + "static/media/icon-coin-services-top.1467ea97.png";